import { formatDate, formatDay, formatDayTime, formatMoney, type PartyRef } from '@reikraft/shared';

export { formatDate, formatDay, formatDayTime, formatMoney };

export const partyKind = (p: PartyRef | null) => (p ? (p.kind === 'organization' ? 'Организация' : 'Частное лицо') : 'Без клиента');

export const partyHref = (p: PartyRef) => (p.kind === 'organization' ? `/organizations/${p.id}` : `/clients/${p.id}`);

/** рубли из поля ввода → копейки */
export function rubToKop(v: string): number | null {
  const clean = v.replace(/[\s₽]/g, '').replace(',', '.');
  if (!clean) return null;
  const n = Number(clean);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

export const kopToRub = (k: number | null | undefined) => (k === null || k === undefined ? '' : String(k / 100));

export function downloadCsv(name: string, rows: (string | number | null | undefined)[][]) {
  const csv = rows.map((r) => r.map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
